import { render, staticRenderFns } from "./recolumn-edit-alipay.vue?vue&type=template&id=4aebab9f&scoped=true&"
import script from "./recolumn-edit-alipay.vue?vue&type=script&lang=js&"
export * from "./recolumn-edit-alipay.vue?vue&type=script&lang=js&"
import style0 from "./recolumn-edit-alipay.vue?vue&type=style&index=0&id=4aebab9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebab9f",
  null
  
)

export default component.exports